import { http } from '../../../api'

const language = {
  namespaced: true,
  state: {
    languages: []
  },
  actions: {
    getLanguages: ({ commit }) => {
      return http.get('/language').then(res => {
        commit('setLanguages', res.data.data)
      })
    },
    getJsonFile: ({ commit }) => {
      return http.get('/language-json').then(res => {
        return res.data.data
      })
    },
    getLanguage: ({ commit }, id) => {
      return http.get('/language/' + id).then(res => {
        return res.data
      })
    },
    getCreateData: ({ commit }) => {
      return http.get('/language/create').then(res => {
        return res.data
      })
    },
    createLanguage: ({ commit }, params) => {
      return http.post('/language', params).then(res => {
        return res
      })
    },
    updateLanguage: ({ commit }, params) => {
      return http.post('/language-update/' + params.id, params.data).then(res => {
        return res
      })
    },
    delete: ({ commit }, id) => {
      return http.delete('/language/' + id).then(res => {
        commit('updateLanguageStatus', { id: id })
      })
    }
  },
  mutations: {
    setLanguages (state, data) {
      state.languages = data
    },
    updateLanguageStatus (state, data) {
      state.languages = state.languages.filter(language => language.id !== data.id)
    },
    updateLanguage (state, data) {
      state.languages = state.languages.map(language => {
        if (language.id === data.id) {
          language = data
        }
        return language
      })
    }
  },
  getters: {
    languages: state => state.languages
  }
}

export default language
